import { useQueryClient } from '@tanstack/react-query';
import { NotificationManager } from 'react-notifications';
import { useApiMutation } from '@/hooks/api/useApiMutation';
import { useGetQuery } from '@/hooks/api/useGetQuery';
import { refreshAfterOrgSwitch } from '@/lib/refresh-after-org-switch';
import { queryKeys } from '@/queries/query-keys';

/** GET `/org/all` — every organization (ROOT only on server). */
export function useAllOrgsQuery(options = {}) {
  return useGetQuery(() => '/org/all', {}, queryKeys.allOrgs(), {
    staleTime: 60_000,
    retry: false,
    ...options,
  });
}

/** GET `/org` — active organization context (includes `impersonated` when applicable). */
export function useActiveOrgQuery(options = {}) {
  return useGetQuery(() => '/org', {}, queryKeys.activeOrg(), {
    staleTime: 30_000,
    retry: false,
    ...options,
  });
}

/** PUT `/org/{orgId}/impersonate` — switch org context (ROOT). Use orgId `0` to reset. */
export function useImpersonateOrgMutation() {
  const queryClient = useQueryClient();

  return useApiMutation(
    (orgId) => `/org/${orgId}/impersonate`,
    'put',
    {},
    {
      onSuccess: async () => {
        await refreshAfterOrgSwitch(queryClient);
      },
      onError: (err) => {
        NotificationManager.error(
          err.message || 'Could not switch organization',
          '',
          4000,
        );
      },
    },
    () => ({}),
  );
}
